import React, { Component, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { observer } from 'mobx-react';

import { AcceptAwardOfferApi } from "../util/api/ServiceObjects/AcceptAwardOfferApi";





let AlertModal = function (props) {

    const showAlerts = props.store.alerts.length > 0;

    //When a user closes the modal, clear the alerts.
    //Setting 'show' to false is unnessarry, as clearing alerts triggers rerender.

    let handleClose = () =>  props.store.clearAlerts();

    let key = 0;
    function getKey() {
        return key++;
    }


    return (
        <Modal
            isOpen={showAlerts}
            toggle={handleClose}

            size = "lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <ModalHeader >
                <div key={getKey()} id="contained-modal-title-vcenter">
                    Alert
                </div>
            </ModalHeader>
            <ModalBody>
                {props.store.alerts.map((alert) => {
                    return (
                        <div key={getKey()}>
                            <h4>{alert.title}</h4>
                            <p>{alert.text}</p>
                        </div>
                        );
                    })
                }
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-primary" onClick={handleClose}>Close</button>
            </ModalFooter>
        </Modal >
    );

}

AlertModal = observer(AlertModal);


export { AlertModal }